// extracted by mini-css-extract-plugin
export default {"alerts_container":"App_alerts_container__P-Byb","actions_container":"App_actions_container__NXqmS","close":"App_close__u9dAC","alert_body":"App_alert_body__GvYLY"};